import React from "react";
import * as RelationUtils from "utils/relation";
import { AliasedProjectionMultiInput } from "./ExpressionInput";
const MutateRelationInput = ({ relation, onChange, exprProvider, isDisabled }) => {
    const aliasFormatter = RelationUtils.getAliasFormatter(relation);
    const exprs = relation?.mutate ?? [];
    const context = RelationUtils.getOutputContext(relation.input);
    const handleChange = (exprs) => onChange(RelationUtils.builder(relation.input).mutate(exprs).build());
    return (React.createElement(AliasedProjectionMultiInput, { context: context, exprs: exprs, onChange: handleChange, exprProvider: exprProvider, isDisabled: isDisabled, aliasFormatter: aliasFormatter }));
};
export default MutateRelationInput;
